/**
 * Component: M56 Company Perks 
 * 
 */
'use strict';

export class CompanyPerks 
{
  constructor()
  {
    this.selectors = {
      component:       $('.c-v4-m56-company-perks'),
      topSliders:      $('.c-v4-m56-company-perks--images-holder-top-img'),
      bottomSliders:   $('.c-v4-m56-company-perks--images-holder-bottom-img')
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  init_slick_carousel()
  {
    this.selectors.topSliders.each(function()
    {
      $(this).slick({
        draggable: false,
        arrows: false,
        dots: false,
        fade: true,
        speed: 2000,
        infinite: true,
        autoplay: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      });
    });

    this.selectors.bottomSliders.each(function()
    {
      $(this).slick({
        draggable: false,
        arrows: false,
        dots: false,
        fade: true,
        speed: 2500,
        infinite: true,
        autoplay: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      });
    });
  }
}
